import { createSelector } from '@ngrx/store';
import * as fromFeature from '../reducers';

export const getTravelSearchTogglesFeatureState = createSelector(
  fromFeature.getTravelBookingState,
  (state: fromFeature.TravelBookingState) => state.travelSearchToggles
);

export const getIsMultiBooking = createSelector(getTravelSearchTogglesFeatureState, (state) => state.multi);
